import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFiles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFiles"><Path fillRule="evenodd" clipRule="evenodd" d="M7 5H4V22H18V19H21V9H14V2H7V5ZM7 7V19H16V20H6V7H7Z" fill="currentColor"/><Path d="M16 2.58579L20.4142 7H16V2.58579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFiles;
